(() => {
 const initialise = (root = document) => root.querySelectorAll('.pp-control-menu').forEach(nav => {
  if (nav.dataset.drilldown) return;
  const grid = nav.querySelector('.pp-control-menu__grid');
  const header = nav.querySelector('.pp-control-menu__navigation');
  if (!grid || !header) return;
  nav.dataset.drilldown = 'true';
  const back = header.querySelector('button'), title = header.querySelector('strong');
  const label = el => (el.matches('details') ? el.querySelector(':scope > summary strong, :scope > summary > span:not(.pp-control-menu__signal)') : el.querySelector('strong,span:not(.pp-control-menu__signal)'))?.textContent.trim() || '';
  const ancestors = el => {
   const chain = [];
   for (let p = el?.parentElement; p && p !== nav; p = p.parentElement) if (p.matches('details')) chain.unshift(p);
   return chain;
  };
  const current = new URL(location.href);
  nav.querySelectorAll('[data-food-brand]').forEach(a => {
   const url = new URL(a.href);
   if (current.pathname.split('/').slice(0,3).join('/') === url.pathname) {
    url.pathname = current.pathname;
    for (const [k,v] of current.searchParams) if (k !== 'filter.p.vendor' && k !== 'page') url.searchParams.set(k,v);
    a.href = url.pathname + url.search;
   }
  });
  let leaf = Array.from(grid.querySelectorAll('a')).find(a => {
   const url = new URL(a.href);
   if (url.pathname !== current.pathname) return false;
   if (current.searchParams.has('filter.p.vendor')) return url.searchParams.get('filter.p.vendor') === current.searchParams.get('filter.p.vendor');
   return !url.searchParams.has('filter.p.vendor');
  });
  let path = leaf ? ancestors(leaf) : [];
  if (leaf?.classList.contains('pp-control-menu__overview')) leaf = null;
  const render = () => {
   nav.querySelectorAll('[data-drill-hidden]').forEach(el => { el.hidden = false; el.removeAttribute('data-drill-hidden'); });
   grid.querySelectorAll('details').forEach(el => { el.open = path.includes(el); });
   const hideOthers = (parent, selected) => Array.from(parent.children).forEach(el => {
    if (el !== selected) { el.hidden = true; el.setAttribute('data-drill-hidden', ''); }
   });
   path.forEach(el => hideOthers(el.parentElement, el));
   if (leaf) hideOthers(leaf.parentElement, leaf);
   header.hidden = !path.length && !leaf;
   title.textContent = [...path.map(label), ...(leaf ? [label(leaf)] : [])].join(' › ');
  };
  nav.addEventListener('click', event => {
   const summary = event.target.closest('summary');
   if (!summary || !grid.contains(summary)) return;
   event.preventDefault();
   const details = summary.parentElement;
   path = [...ancestors(details), details]; leaf = null;
   render(); back.focus({preventScroll:true});
  });
  back.addEventListener('click', () => {
   const target = leaf || path.at(-1)?.querySelector('summary');
   if (leaf) leaf = null; else path.pop();
   render(); target?.focus({preventScroll:true});
  });
  render();
 });
 initialise();
 document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
